import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { Product } from 'models/product'

type CustomFields = 'default_sales' | 'variants_count'

export const PRODUCTS_COLUMNS = {
  name: {
    header: 'Product Name',
    group: 'Product Details',
  },
  format: {
    header: 'Format',
    group: 'Product Details',
  },
  product_format: {
    header: 'Product Format',
    group: 'Product Details',
  },
  mfg_avg_list_price_per_lb: {
    header: 'Avg. Price per Unit',
    group: 'Product Metrics',
  },
  est_monthly_churn_rate: {
    header: 'Est. Monthly Churn Rate',
    group: 'Product Metrics',
  },
  default_sales: {
    header: 'Avg. Units Sold per Month',
    group: 'Product Metrics',
  },
  variants_count: {
    header: 'Variants',
    group: 'Product Details',
  },
  unit: {
    header: 'Unit',
    group: 'Product Details',
  },
  lbs_per_case: {
    header: 'Lbs per Case',
    group: 'Product Metrics',
  },
  value_per_consumer_new_trial: {
    header: 'Value per Consumer New Trial',
    group: 'Product Metrics',
  },
  current_aided_awareness: {
    header: 'Current Aided Awareness',
    group: 'Product Metrics',
  },
  current_national_trial_perc: {
    header: 'Current National Trial %',
    group: 'Product Metrics',
  },
  created: {
    header: 'Date Created',
    group: 'Activity',
  },
  modified: {
    header: 'Last Modified',
    group: 'Activity',
  },
} satisfies Partial<Record<keyof Product | CustomFields, DataTypeColumn>>
